<template>
  <el-drawer
    :visible.sync="visible"
    :modal="false"
    :withHeader="false"
    :wrapperClosable="false"
    :size="isMobile ? '100%' : '34.7vw'"
    custom-class="epaperArticleDetailWrap"
    :style="isMobile ? { height: '101%' } : { height: `${drawerHeight}px !important`, top: `${drawerTop}px !important` }"
  >
    <div class="header">
      <div class="headTitle">{{ article.headTitle }}</div>
      <div class="title">{{ article.mainTitle }}</div>
      <div class="subTitle">{{ article.subTitle }}</div>
    </div>
    <div class="content">
      <div class="contentHeader">
        <div class="timeAuthor">{{ article.timeAuthor }}</div>
        <div class="readBut" @click="dealOpenRead">语音阅读</div>
      </div>
      <div class="contentPic">
        <div class="picImage">
          <img :src="article.picsUrl" alt="picImage" />
        </div>
        <div class="picDesc">{{ article.picsDesc }}</div>
      </div>
      <div class="contentPara">
        <div v-for="(para, index) in article.textParas" class="paraItem" :key="index">{{ para }}</div>
      </div>
    </div>
    <div class="articleFooter">
      <div class="audio" v-show="showRead">
        <div class="iconRead"></div>
        <div class="readingText">正在收听{{ article.headTitle }}</div>
        <div v-if="isPlaying" class="iconPause" @click="dealPause"></div>
        <div v-else class="iconPlay" @click="dealPlay"></div>
        <div class="iconClose" @click="dealCloseRead"></div>
      </div>
      <div class="oper">
        <div class="operPage">
          <div class="prevPage" @click="dealPrevPage">上一篇</div>
          <div class="nextPage" @click="dealNextPage">下一篇</div>
        </div>
        <div class="operFont">
          <div class="fontPlus" @click="dealFontPlus"></div>
          <div class="fontMinus" @click="dealFontMinus"></div>
        </div>
      </div>
    </div>
  </el-drawer>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      visible: true, // 抽屉是否可见
      drawerHeight: 0, // 抽屉高度
      drawerTop: 0, // 抽屉top位置
      article: {
        headTitle: '攀钢高端热基镀锌钢板通过本田汽车认证',
        mainTitle: '美开发出高度控制金属纳米结构的方法可使多孔金属薄膜的导电性提高1000倍',
        subTitle: '西昌钢钒收到本田汽车专家团队的产品认证函',
        timeAuthor: '2021年11月11日 高飞',
        picsUrl: '//digitalpaper.stdaily.com/http_www.kjrb.com/kjrb/images/2021-11/24/04/1615761_lix_1637647604017_b.jpg',
        picsDesc: '这是攀钢自主开发的高端热基镀锌钢板再次获得国内合资品牌汽车主机厂认证。',
        textParas: [
          '本报讯 （特约记者 高飞 通讯员 张龙超）日前，西昌钢钒收到本田汽车专家团队的产品认证函，来函中确认由攀钢生产的热基镀锌钢板系列中的2个牌号FB60和H440B高端钢板产品，完全满足本田汽车使用标准要求。',
          '据了解，此次通过本田汽车认证热基镀锌钢板，是一种“以热代冷”、性价比高的高端产品，能有效降低用户采购成本，有着良好市场前景，但在生产中，其表面质量、整卷性能等控制难度极大。'
        ]
      },
      isPlaying: false,
      showRead: false
    }
  },
  computed: {
    ...mapState('book', ['isMobile'])
  },
  methods: {
    // 调整抽屉高度
    setHeight() {
      if (this.isMobile) {
        this.drawerHeight = window.innerHeight
      } else {
        const tgt = document.getElementsByClassName('book-wrapper')[0]
        const tgt1 = document.getElementsByClassName('book-title')[0]
        if (tgt && tgt1) {
          this.drawerHeight = tgt.clientHeight - 80 // 减去header高度40，footer高度40
          this.drawerTop = tgt1.getBoundingClientRect().bottom
        }
      }
      // 触发滚动条样式自适应
      // this.drawerHeight = this.drawerHeight - 1
      // setTimeout(() => {
      //   this.drawerHeight = this.drawerHeight + 1
      // }, 0)
    },
    dealPause() {
      this.isPlaying = false
    },
    dealPlay() {
      this.isPlaying = true
    },
    dealOpenRead() {
      this.showRead = true
    },
    dealCloseRead() {
      this.showRead = false
    },
    dealPrevPage() {
      console.log('dealPrevPage')
    },
    dealNextPage() {
      console.log('dealNextPage')
    },
    dealFontPlus() {
      console.log('dealFontPlus')
    },
    dealFontMinus() {
      console.log('dealFontMinus')
    }
  },
  mounted() {
    setTimeout(() => {
      this.setHeight()
    }, 0)
  },
  created() {
    window.addEventListener('resize', this.setHeight)
  },
  destroyed() {
    window.removeEventListener('resize', this.setHeight)
  }
}
</script>
<style lang="scss">
@mixin clickIcon {
  background: no-repeat center/1.1vw;
  height: 1.1vw;
  width: 1.1vw;
  cursor: pointer;
}
@mixin iconPlayPause {
  margin: 0 1vw 0 2.2vw;
}
.epaperArticleDetailWrap {
  background-color: #fff;
  padding: 0 2.1vw 0;
  overflow: hidden;
  .header {
    border-bottom: 0.1vw solid #eee;
    .headTitle,
    .subTitle {
      font-size: 1.1vw;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #999999;
      line-height: 1.5vw;
    }
    .headTitle {
      padding-top: 1.3vw;
    }
    .subTitle {
      padding-bottom: 0.7vw;
    }
    .title {
      font-size: 1.7vw;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #3a3a3a;
      line-height: 2.1vw;
      padding: 0.4vw 0;
    }
  }
  .content {
    padding-bottom: 1.6vw;
    .contentHeader {
      display: flex;
      justify-content: space-between;
      padding-top: 0.6vw;
      .timeAuthor {
        font-size: 1vw;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #999999;
        line-height: 1.4vw;
      }
      .readBut {
        cursor: pointer;
        width: 6.7vw;
        height: 1.5vw;
        border-radius: 0.3vw;
        border: 0.1vw solid #df5813;
        font-size: 0.9vw;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #df5813;
        line-height: 1.3vw;
        padding-left: 2.4vw;
        background: url('../../../assets/imgs/read-article.png') no-repeat 0.7vw center/1.3vw;
      }
    }
    .contentPic {
      .picImage {
        height: 18.1vw;
        padding-top: 0.8vw;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .picDesc {
        font-size: 1vw;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #999999;
        line-height: 1.5vw;
        padding-top: 0.6vw;
      }
    }
    .contentPara {
      .paraItem {
        font-size: 1.1vw;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #3a3a3a;
        line-height: 2.1vw;
        text-indent: 2em;
        padding-top: 0.8vw;
      }
    }
  }
  .articleFooter {
    padding-bottom: 0.8vw;
    position: sticky;
    bottom: 0;
    background: #fff;
    .audio {
      height: 2.5vw;
      background: #eaeaea;
      display: flex;
      align-items: center;
      .iconRead {
        background: url('../../../assets/imgs/read-article.png') no-repeat center/1.3vw;
        height: 1.3vw;
        width: 1.3vw;
        margin-right: 0.5vw;
      }
      .readingText {
        font-size: 1.1vw;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #3a3a3a;
        line-height: 1.5vw;
        width: 23.3vw;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      .iconPlay {
        @include clickIcon;
        @include iconPlayPause;
        background-image: url('../../../assets/imgs/audio-play.png');
      }
      .iconPause {
        @include clickIcon;
        @include iconPlayPause;
        background-image: url('../../../assets/imgs/audio-pause.png');
      }
      .iconClose {
        @include clickIcon;
        background-image: url('../../../assets/imgs/audio-close.png');
      }
    }
    .oper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-top: 0.7vw;
      .operPage {
        font-size: 1.1vw;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #3a3a3a;
        line-height: 1.5vw;
        display: flex;
        .prevPage,
        .nextPage {
          cursor: pointer;
        }
        .prevPage {
          margin-right: 1.5vw;
        }
      }
      .operFont {
        display: flex;
        .fontPlus,
        .fontMinus {
          background: no-repeat center/2.1vw;
          height: 2.1vw;
          width: 2.1vw;
          cursor: pointer;
        }
        .fontPlus {
          background-image: url('../../../assets/imgs/font-plus.png');
          &:hover {
            background-image: url('../../../assets/imgs/font-plus-hover.png');
          }
        }
        .fontMinus {
          background-image: url('../../../assets/imgs/font-minus.png');
          margin-left: 2.1vw;
          &:hover {
            background-image: url('../../../assets/imgs/font-minus-hover.png');
          }
        }
      }
    }
  }
  .el-drawer__body::-webkit-scrollbar {
    width: 0;
  }
}
</style>
